import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DrillDownDetails } from '../../models/ui-models/drill-down-details.model';
import { AppMetaDataItemNames, UsersManageUsersCourseProgressGridQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { DwGridEvent } from '@devwareapps/devware-cap';
import { ViewStudentInfo } from '../../models/ui-models/view-student-info.model';

@Component({
  selector: 'app-reporting-users-detail-grid',
  template: `
    <dw-meta-data-grid [item]="item" [configKeyPart]="'reporting-users'" [filters]="filters" (gridEvent)="onGridEvent($event)"></dw-meta-data-grid>
  `
})
export class ReportingUsersDetailGridComponent implements OnInit, OnChanges {
  item = AppMetaDataItemNames.DwUser;

  @Input() drillDownDetails: DrillDownDetails;
  @Output() backToOverview = new EventEmitter<void>();
  @Output() viewStudent = new EventEmitter<ViewStudentInfo>();

  filters: any;

  constructor() { }

  ngOnInit(): void {
    this.setupFilters();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setupFilters();
  }

  setupFilters() {
    this.filters = {
      StudentCourseStudentCourseId: {
        IN: this.drillDownDetails?.studentCourseIds || []
      }
    }
  }

  onGridEvent(event: DwGridEvent) {
    if (event.eventCommand == 'gridPassthrough') {
      this.backToOverviewClick();
    }
    if (event.eventType == 'gridRowClick' || event.actionPreference?.actionDisplay == 'Edit') {
      const data: UsersManageUsersCourseProgressGridQueryEntity = event.eventData;

      const viewStudentInfo : ViewStudentInfo = { 
        studentCourseId: data.StudentCourseStudentCourseId,
        userId: data.UserId
      };

      this.viewStudent.emit(viewStudentInfo);
    }
  }

  backToOverviewClick() {
    this.backToOverview.emit();
  }
}
